module.exports = __webpack_public_path__ + "img/rencai_hover.4070f73d.png";